module.exports = __webpack_public_path__ + "img/symbol_6.7e35af0b.png";